<template>
  <div class="backyanse">
    <MyHelloWorld :numer="number"></MyHelloWorld>
    <!-- 右边图标 -->
    <Righticon></Righticon>
    <el-row>
      <el-col :span="24">
        <el-container class="conta auto">
          <el-image class="img" :src="$t('menu.SurveyandQuotationImg')" alt=""></el-image>
        </el-container>
      </el-col>
    </el-row>
    <div class="content">
      <el-row>
        <el-col :span="7">
          <Content>
            <template #MingChen>
              <div>{{ $t("menu.contactUs") }}</div>
            </template>

            <template #ContentEr>
              <div class="inlineer">
                <li><router-link to="/SurveyandQuotation"> <div style="color: #1d2088">{{ $t("menu.SurveyAndQuotation") }} </div></router-link></li> 
              </div>
            </template>  
          </Content>
        </el-col>
        <el-col :span="17">
          <div class="inline">
            <el-divider direction="vertical"></el-divider>
            <h3 class="Xjiao">{{ $t("menu.SurveyAndQuotation") }}</h3>
          </div>
            <div class="fff">
            <div v-for="(item,index) in ProjectList" :key="index">
            <span>{{item.region}}</span>
            <p>{{ $t("menu.tel") }} {{item.tel}}</p>
            <p>{{ $t("menu.fax") }}{{item.fax}}</p>
            <p>{{ $t("menu.mailbox") }}{{item.mailbox}}</p>
            <p>{{ $t("menu.companyAddress") }}{{item.companyAddress}}</p>
            <p>{{ $t("menu.businessHours") }} {{item.businessHours}}</p>
            <p>
              {{ $t("menu.detectionRange") }} {{item.detectionRange}}
            </p>
            <br />
            <br />
          </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 底部 -->  
    <MyFooter> </MyFooter>
  </div>
</template>


<style scoped>
.White {
  position: relative;
  top: 69px;
  height: 60px;
  width: 280px;
  background: #999999;
}
.conta {
  margin-top: 161px;
}
.SanJiao {
  position: relative;
  bottom: 40px;
  left: 228px;
}

.shisi {
  font-size: 14px;
  background: #ffffff;
  padding: 10px;
  padding-left: 20px;
}
.Xjiao {
  color: #1d2088;
  font-size: 20px;
}

.divider {
  background-color: #eeeeee;
}
.fff {
  background: #ffffff;
  padding: 20px;
  margin-bottom: 20px;
  padding-top: 0px;
}
span {
  font-size: 16px;

  color: #333333;
}
p {
  color: #666666;
  font-size: 12px;
}
a:-webkit-any-link {
  color: -webkit-link;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
a:-webkit-any-link:focus,
a:-webkit-any-link:hover {
  color: #1d2088;
}
</style>

<script>
export default {
  name: "SurveyandQuotation",

  data() {
    return {
      number: "6",

      ProjectList:[]
    };
  },
     created: function () {
    if (this.$i18n.locale == "TC") {
      this.title = "TC";
    } else if (this.$i18n.locale == "EN") {
      this.title = "EN";
    } else if (this.$i18n.locale == "SC") {
      this.title = "SC";
    }
    this.getSelectRubber()
    },
  methods: {
   async getSelectRubber() {
      const { data: res } = await this.$http.get(
        "/ContactUs/GetContactInfo",
        {
          params:{languageType: this.title },
        }
      );

      if (res.code !== 200) return console.log("数据请求失败! ");

      this.ProjectList = res.data;


    },
  },
};
  
</script>